import React, { useState } from 'react';
import {
  CheckCircle2,
  XCircle,
  RefreshCw,
  Clock,
  GitBranch,
  List,
  Timer,
  MousePointer,
  Activity,
  ChevronDown,
  ChevronUp
} from 'lucide-react';

// â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€
// ReviewGate
// â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€
const ReviewGate = ({ execution, onApprove, onReject, onRegenerate, loading }) => {
  const [showRejectModal, setShowRejectModal] = useState(false);
  const [rejectReason, setRejectReason] = useState('');

  const handleReject = () => {
    if (rejectReason.trim()) {
      onReject(rejectReason);
      setShowRejectModal(false);
      setRejectReason('');
    }
  };

  if (execution.status === 'approved') {
    return (
      <div className="bg-green-50 border border-green-200 rounded-lg p-4">
        <div className="flex items-center gap-2 text-green-700">
          <CheckCircle2 className="w-5 h-5" />
          <span className="font-medium">Execution approvata</span>
        </div>
      </div>
    );
  }

  if (execution.status === 'rejected') {
    return (
      <div className="bg-red-50 border border-red-200 rounded-lg p-4">
        <div className="flex items-center gap-2 text-red-700">
          <XCircle className="w-5 h-5" />
          <span className="font-medium">Execution rigettata</span>
        </div>
        {execution.rejectionReason && (
          <p className="text-sm text-red-600 mt-2">{execution.rejectionReason}</p>
        )}
      </div>
    );
  }

  return (
    <>
      <div className="bg-white border border-gray-200 rounded-lg p-4">
        <h3 className="font-medium text-gray-800 mb-3">Revisiona Output</h3>
        <div className="flex gap-3">
          <button onClick={() => onApprove()} disabled={loading}
            className="flex-1 flex items-center justify-center gap-2 px-4 py-2 bg-green-600 text-white rounded-lg hover:bg-green-700 transition-colors disabled:opacity-50">
            <CheckCircle2 className="w-4 h-4" /> Approva
          </button>
          <button onClick={onRegenerate} disabled={loading}
            className="flex-1 flex items-center justify-center gap-2 px-4 py-2 bg-blue-600 text-white rounded-lg hover:bg-blue-700 transition-colors disabled:opacity-50">
            <RefreshCw className="w-4 h-4" /> Rigenera
          </button>
          <button onClick={() => setShowRejectModal(true)} disabled={loading}
            className="flex-1 flex items-center justify-center gap-2 px-4 py-2 bg-red-600 text-white rounded-lg hover:bg-red-700 transition-colors disabled:opacity-50">
            <XCircle className="w-4 h-4" /> Rigetta
          </button>
        </div>
      </div>

      {showRejectModal && (
        <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50">
          <div className="bg-white rounded-lg p-6 max-w-md w-full mx-4">
            <h3 className="text-lg font-semibold mb-4">Motivo del Rigetto</h3>
            <textarea value={rejectReason} onChange={(e) => setRejectReason(e.target.value)}
              placeholder="Spiega perchÃ© rigetti questa execution..."
              className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-red-500 focus:border-transparent"
              rows={4} />
            <div className="flex gap-3 mt-4">
              <button onClick={() => setShowRejectModal(false)}
                className="flex-1 px-4 py-2 border border-gray-300 rounded-lg hover:bg-gray-50">
                Annulla
              </button>
              <button onClick={handleReject} disabled={!rejectReason.trim()}
                className="flex-1 px-4 py-2 bg-red-600 text-white rounded-lg hover:bg-red-700 disabled:opacity-50">
                Conferma Rigetto
              </button>
            </div>
          </div>
        </div>
      )}
    </>
  );
};

// â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€
// BlueprintCard
// â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€
const BlueprintCard = ({ blueprint = {} }) => {
  const [expanded, setExpanded] = useState(true);
  if (!blueprint || typeof blueprint !== 'object' || !Object.keys(blueprint).length) return null;

  return (
    <div className="rounded-lg border border-orange-200 overflow-hidden">
      <button
        onClick={() => setExpanded(!expanded)}
        className="w-full flex items-center justify-between p-4 bg-orange-50 hover:bg-orange-100 transition-colors"
      >
        <div className="flex items-center gap-2">
          <GitBranch className="w-4 h-4 text-orange-700" />
          <span className="text-xs font-semibold text-orange-700 uppercase tracking-wide">Script Structure Blueprint</span>
          <span className="text-xs text-orange-500">(inferential execution graph)</span>
        </div>
        {expanded ? <ChevronUp className="w-4 h-4 text-orange-400" /> : <ChevronDown className="w-4 h-4 text-orange-400" />}
      </button>
      {expanded && (
        <div className="bg-orange-50 border-t border-orange-100 p-4 space-y-3">
          {Object.entries(blueprint).map(([key, value]) => (
            <div key={key}>
              <span className="text-xs font-semibold text-orange-600 uppercase tracking-wide">
                {key.replace(/_/g, ' ')}
              </span>
              {Array.isArray(value) ? (
                <ul className="mt-1 space-y-1">
                  {value.map((item, i) => (
                    <li key={i} className="flex items-start gap-2">
                      <span className="w-4 h-4 flex-shrink-0 flex items-center justify-center rounded-full bg-orange-100 text-orange-600 text-xs">{i + 1}</span>
                      <p className="text-sm text-gray-700">{typeof item === "string" ? item : JSON.stringify(item)}</p>
                    </li>
                  ))}
                </ul>
              ) : (
                <p className="text-sm text-gray-700 mt-1 leading-relaxed">{String(value)}</p>
              )}
            </div>
          ))}
        </div>
      )}
    </div>
  );
};

// â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€
// IndexedList
// â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€
const IndexedList = ({ icon: Icon, title, subtitle, items = [], colorClass, bgClass }) => {
  if (!items.length) return null;
  return (
    <div className={`rounded-lg border overflow-hidden`}>
      <div className={`flex items-center gap-2 p-3 ${bgClass}`}>
        <Icon className={`w-4 h-4 ${colorClass}`} />
        <span className={`text-xs font-semibold uppercase tracking-wide ${colorClass}`}>{title}</span>
        {subtitle && <span className={`text-xs ${colorClass} opacity-60`}>({subtitle})</span>}
        <span className="ml-auto text-xs text-gray-400">{items.length} entries</span>
      </div>
      <ol className="divide-y divide-gray-100 bg-white">
        {items.map((item, i) => (
          <li key={i} className="flex items-start gap-3 p-3">
            <span className={`w-6 h-6 flex-shrink-0 flex items-center justify-center rounded-full text-xs font-bold ${colorClass} bg-gray-50 border border-current`}>
              {i + 1}
            </span>
            <p className="text-sm text-gray-700 leading-relaxed">{typeof item === "string" ? item : JSON.stringify(item)}</p>
          </li>
        ))}
      </ol>
    </div>
  );
};

// â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€
// EmptyState
// â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€
const EmptyState = () => (
  <div className="flex items-center justify-center h-full">
    <div className="text-center text-gray-500">
      <Clock className="w-12 h-12 mx-auto mb-4 text-gray-300" />
      <p className="text-lg font-medium mb-2">In attesa di esecuzione</p>
      <p className="text-sm">Clicca "Esegui Contract" per avviare lo Script Structure Layer</p>
    </div>
  </div>
);

// â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€
// Contract08View
// â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€â”€
const Contract08View = ({ execution, onApprove, onReject, onRegenerate, loading }) => {
  if (!execution) return <EmptyState />;

  const output = execution.output || execution.outputData || {};

  return (
    <div className="h-full overflow-y-auto p-6">
      <div className="max-w-4xl mx-auto space-y-6">

        {/* Header */}
        <div>
          <div className="flex items-center gap-3 mb-1">
            <GitBranch className="w-6 h-6 text-orange-600" />
            <h2 className="text-xl font-bold text-gray-800">Script Structure Layer</h2>
            <span className="px-2 py-0.5 text-xs bg-orange-100 text-orange-700 rounded-full font-medium">C08</span>
          </div>
          <p className="text-sm text-gray-500">Blueprint inferenziale dello script â€” architettura cognitiva, non struttura narrativa</p>
        </div>

        {/* Script Structure Blueprint */}
        <BlueprintCard blueprint={output.script_structure_blueprint} />

        {/* CTA Function */}
        {output.cta_function && (
          <div className="bg-purple-50 border border-purple-200 rounded-lg p-4">
            <div className="flex items-center gap-2 mb-2">
              <MousePointer className="w-4 h-4 text-purple-700" />
              <span className="text-xs font-semibold text-purple-700 uppercase tracking-wide">CTA Function</span>
              <span className="text-xs text-purple-500">(cognitive function, not wording or placement)</span>
            </div>
            <p className="text-sm text-gray-700 leading-relaxed">{output.cta_function}</p>
          </div>
        )}

        {/* Arrays */}
        <div className="space-y-4">
          <IndexedList
            icon={List}
            title="Scene Logic"
            subtitle="logical observation sequence, not cinematic scenes"
            items={output.scene_logic}
            colorClass="text-blue-700"
            bgClass="bg-blue-50"
          />
          <IndexedList
            icon={Timer}
            title="Proof Timing"
            subtitle="inferential schedule, not editing timing"
            items={output.proof_timing}
            colorClass="text-green-700"
            bgClass="bg-green-50"
          />
          <IndexedList
            icon={Activity}
            title="Prediction Error Distribution"
            subtitle="expectation violations, not emotional pacing"
            items={output.prediction_error_distribution}
            colorClass="text-red-700"
            bgClass="bg-red-50"
          />
        </div>

        {/* Review Gate */}
        <ReviewGate
          execution={execution}
          onApprove={onApprove}
          onReject={onReject}
          onRegenerate={onRegenerate}
          loading={loading}
        />
      </div>
    </div>
  );
};

export default Contract08View;

